const base_url = "http://5.206.204.97:5000"
export default base_url